import { Reducer } from 'redux';
import { ActionType } from 'typesafe-actions';
import { MediaActions } from '../actions';
import { ActionTypes, MediaState, TAction } from '../types';
import { initializeTreeCache } from '../visibleTreeCache';

type MediaAction = ActionType<typeof MediaActions>;

export const InitialMediaState: MediaState = {
  isLoading: false,
  loadingError: undefined,
  lastToggled: undefined,
  tree: [],
  medias: {}
};

export const medias: Reducer<MediaState> = (state: MediaState = InitialMediaState, action: MediaAction) => {
  switch (action.type) {
    case ActionTypes.FETCH_MEDIAS_REQUEST: {
      return { ...state, isLoading: true };
    }
    case ActionTypes.FETCH_MEDIAS_SUCCESS: {
      const firstLevel = action.payload.tree.filter(treeItem => treeItem.level <= 2);
      firstLevel.filter(treeItem => treeItem.level < 2).forEach(treeItem => (treeItem.isExpanded = true));
      initializeTreeCache(firstLevel);
      return {
        ...state,
        isLoading: false,
        medias: action.payload.medias,
        tree: action.payload.tree,
        lastToggled: undefined
      };
    }
    case ActionTypes.FETCH_MEDIAS_ERROR: {
      return { ...state, isLoading: false, loadingError: action.payload };
    }
    case ActionTypes.EXPAND: {
      return { ...state, lastToggled: { treeId: action.payload, action: TAction.Expand } };
    }
    case ActionTypes.COLLAPSE: {
      return { ...state, lastToggled: { treeId: action.payload, action: TAction.Collapse } };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/medias.ts